import React, { useState } from 'react';
import ReactModal from 'react-modal';

import { createToolTip, retrieveToolTip, updateToolTip } from '../../../services/ToolTipService';

import { SaveButton } from '../button/save-button/SaveButton';

import tooltip from '../../../resources/images/tooltip.png';

import './ToolTip.css';

export const ToolTip = ({ context, fieldName, tooltipExternalReference, showToaster, setSpinnerText }) => {
  ReactModal.setAppElement('#root');

  const [retrievedToolTip, setRetrievedToolTip] = useState(null);
  const [message, setMessage] = useState('Create new tool tip message..');
  const [retrievedMessage, setRetrievedMessage] = useState('Create new tool tip message..');
  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  const handleShow = async () => {
    setShow(true);
    await fetchToolTip();
  };

  const handleUpdate = () => setShowUpdate(!showUpdate);

  const handleClose = () => {
    setShow(false);
    setShowUpdate(false);
  };

  const handleSubmitClick = async () => {
    const toolTipToBeSaved = {
      externalReference: tooltipExternalReference,
      tooltip: message,
      systemUserName: context.username,
      contextExternalReference: null,
      contextName: 'Problem',
    };
    if (retrievedToolTip === null) {
      setSpinnerText('Creating ToolTip');
      const response = await createToolTip(context.username, toolTipToBeSaved);
      handleResponse(response);
    } else {
      setSpinnerText('Updating ToolTip');
      const response = await updateToolTip(context.username, toolTipToBeSaved);
      handleResponse(response);
    }
    setShow(!show);
    setShowUpdate(false);
    setRetrievedMessage(message);
  };

  const handleResponse = ([data, error]) => {
    if (data) {
      showToaster(data);
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
  };

  const fetchToolTip = async () => {
    const [data] = await retrieveToolTip(context.username, tooltipExternalReference);
    if (data) {
      if (data.responseStatus === 'Success') {
        const toolTip = data.tooltipVOToView;
        if (toolTip) {
          setRetrievedToolTip(toolTip);
          setRetrievedMessage(toolTip.tooltip);
          setMessage(toolTip.tooltip);
        }
        setSpinnerText(null);
      }
    }
  };

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  return (
    <div className="tooltip-container">
      <button tabIndex="-1" className="info-icon-button" onClick={handleShow}>
        <img src={tooltip} alt={'tooltip-icon'} className={'fa-icon-t'} />
      </button>

      <ReactModal isOpen={show} className="modal-content-t" overlayClassName="modal-overlay">
        <p className={'modal-header-t'}>{fieldName}</p>
        <div className={'modal-info-group'}>
          {showUpdate && (
            <textarea className={'text-input-t'} onChange={handleMessageChange} spellCheck="true" value={message} />
          )}
          {!showUpdate && <textarea className={'text-box-t'} value={retrievedMessage} readOnly />}
        </div>
        <div className={'modal-button-group'}>
          {showUpdate && <SaveButton onClick={handleUpdate} title={'Back'} color={'#077187'} textColor={'#FFFFFF'} />}
          {!showUpdate && (
            <SaveButton
              onClick={handleClose}
              title={'  Ok  '}
              color={'#FFFFFF'}
              textColor={'#077187'}
              border={'2px solid #077187'}
            />
          )}
          {showUpdate && <SaveButton onClick={handleSubmitClick} title={'Save'} color={'#077187'} />}
          {!showUpdate && (
            <SaveButton onClick={handleUpdate} title={'Update'} color={'#077187'} border={'2px solid #077187'} />
          )}
        </div>
      </ReactModal>
    </div>
  );
};
